/* =========================================================
   Million Cases CRO kit
   File: assets/mc-cro.js  (load with defer, once, in theme.liquid)
   Powers: buy box, sticky add-to-bag bar, cart drawer, cart page.
   Talks only to Shopify's public Ajax Cart API, so it works on any theme.
   Settings come from the JSON block rendered by snippets/mc-cro-config.liquid
   ========================================================= */
(function () {
  'use strict';

  /* ---------------- Config ---------------- */
  var DEFAULTS = {
    caseProductType: 'Cases',
    tiersLive: true,                       // set false until the automatic discounts exist in Shopify
    tiers: [{ qty: 2, pct: 15 }, { qty: 3, pct: 20 }],
    prepaidSaving: 100,                    // rupees off when paying online
    codMin: 399, codMax: 4999,             // from the store's refund/COD policy
    cutoffHour: 16, workDays: [1, 2, 3, 4, 5, 6], metroDays: 2, restDays: 4,
    metroPinPrefixes: ['110', '400', '560', '500', '600', '411', '700', '380', '160', '122', '201'],
    refundLine: '7-day refund to your bank account',
    modelOption: 0, colorOption: 1, packOption: 2,     // zero-based position of each option
    packLabels: { 'Case 1': 'Case only', 'Case 2': 'Case + 9H glass', 'Case 3': 'Full setup' },
    packItems: {
      'Case 1': ['Air Pro Case'],
      'Case 2': ['Air Pro Case', 'Edge-to-edge 9H glass with applicator'],
      'Case 3': ['Air Pro Case', 'Edge-to-edge 9H glass with applicator', 'USB-C cable protector']
    },
    basePack: 'Case 1', topPack: 'Case 3', defaultPack: 'Case 3', mostPicked: 'Case 3',
    colorHex: {
      'Midnight Black': '#1b1d22', 'Glacier': '#cfe3f2', 'Burgundy': '#6b1f2b', 'Brilliant Blue': '#2a5bd7',
      'White': '#f4f4f2', 'Purple': '#8a6fbf', 'Cosmic Orange': '#e0782f', 'Silver': '#c9ccd1'
    },
    emptyLinks: [],                        // [{label, url}] quick links for the empty bag
    checkoutPath: 'checkout'
  };
  var cfgEl = document.getElementById('mc-cro-config');
  var CFG = Object.assign({}, DEFAULTS, cfgEl ? safeJSON(cfgEl.textContent) : {});
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* ---------------- Helpers ---------------- */
  function safeJSON(t) { try { return JSON.parse(t); } catch (e) { return {}; } }
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(paise) { return '₹' + Math.round(paise / 100).toLocaleString('en-IN'); }
  function slug(s) { return String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, ''); }
  function packLabel(p) { return CFG.packLabels[p] || p; }
  function track(event, data) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: event }, data || {}));
    document.dispatchEvent(new CustomEvent(event.replace(/_/g, ':'), { detail: data }));
  }
  function imgSized(url, w) {
    if (!url) return '';
    try { var u = new URL(url, location.origin); u.searchParams.set('width', w); return u.toString(); } catch (e) { return url; }
  }
  function isApple(model) { return !/galaxy|samsung/i.test(model); }
  function store(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; } }

  /* ---------------- Delivery dates (honest, based on the shipping policy) ---------------- */
  function isWork(d) { return CFG.workDays.indexOf(d.getDay()) > -1; }
  function dispatchDay(now) {
    var d = new Date(now);
    if (isWork(d) && d.getHours() < CFG.cutoffHour) return d;
    do { d.setDate(d.getDate() + 1); } while (!isWork(d));
    return d;
  }
  function addWork(d, n) { var x = new Date(d); while (n > 0) { x.setDate(x.getDate() + 1); if (isWork(x)) n--; } return x; }
  function fmtDay(d) { return d.toLocaleDateString('en-IN', { weekday: 'short', day: 'numeric', month: 'short' }); }
  function shipLine(now) {
    now = now || new Date();
    var cutoff = new Date(now); cutoff.setHours(CFG.cutoffHour, 0, 0, 0);
    if (isWork(now) && now < cutoff) {
      var mins = Math.max(1, Math.round((cutoff - now) / 60000));
      var h = Math.floor(mins / 60), m = mins % 60;
      return 'Order in <b>' + (h ? h + 'h ' : '') + m + 'm</b> and it ships today';
    }
    var d = dispatchDay(now);
    return 'Ships <b>' + fmtDay(d) + '</b>, first thing in the morning';
  }
  function deliveryRange(pin) {
    var d = dispatchDay(new Date());
    if (pin) {
      var metro = CFG.metroPinPrefixes.some(function (p) { return pin.indexOf(p) === 0; });
      var days = metro ? CFG.metroDays : CFG.restDays;
      return { metro: metro, text: fmtDay(addWork(d, days)) };
    }
    return { text: fmtDay(addWork(d, CFG.metroDays)) + ' to ' + fmtDay(addWork(d, CFG.restDays)) };
  }

  /* ---------------- Cart API (swap via window.MC_API for testing) ---------------- */
  function asJSON(r) {
    return r.json().catch(function () { return {}; }).then(function (d) {
      if (!r.ok) throw new Error(d.description || d.message || 'Something went wrong. Please try again.');
      return d;
    });
  }
  var JSONH = { 'Content-Type': 'application/json', Accept: 'application/json' };
  var productCache = {};
  var api = window.MC_API || {
    get: function () { return fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } }).then(asJSON); },
    add: function (items) { return fetch(ROOT + 'cart/add.js', { method: 'POST', headers: JSONH, body: JSON.stringify({ items: items }) }).then(asJSON); },
    change: function (key, qty) { return fetch(ROOT + 'cart/change.js', { method: 'POST', headers: JSONH, body: JSON.stringify({ id: key, quantity: qty }) }).then(asJSON); },
    product: function (handle) { return fetch(ROOT + 'products/' + handle + '.js', { headers: { Accept: 'application/json' } }).then(asJSON); }
  };
  function getProduct(handle) {
    if (!productCache[handle]) productCache[handle] = api.product(handle);
    return productCache[handle];
  }

  /* =========================================================
     CART RENDERING (shared by drawer and /cart page)
     ========================================================= */
  var cartState = null;
  var picker = { model: null, color: null };   // state for the "add a case for someone" mini picker

  function isCase(item) { return !CFG.caseProductType || item.product_type === CFG.caseProductType; }
  function caseCount(cart) { return cart.items.filter(isCase).reduce(function (n, i) { return n + i.quantity; }, 0); }
  function optOf(item, idx) { return (item.variant_options || [])[idx]; }

  function tierHTML(cart) {
    if (!CFG.tiersLive || !CFG.tiers.length) return '';
    var n = caseCount(cart); if (!n) return '';
    var tiers = CFG.tiers.slice().sort(function (a, b) { return a.qty - b.qty; });
    var max = tiers[tiers.length - 1].qty;
    var next = tiers.filter(function (t) { return t.qty > n; })[0];
    var current = tiers.filter(function (t) { return t.qty <= n; }).pop();
    var msg;
    if (next) {
      var more = next.qty - n;
      msg = 'Add ' + more + ' more case' + (more > 1 ? 's' : '') + ' and every case gets <b>' + next.pct + '% off</b>';
      if (current) msg += '<span class="mc-summary__hint"> · ' + current.pct + '% off already applied</span>';
    } else {
      msg = '<b>' + current.pct + '% off every case unlocked.</b> Mix phones and colours freely.';
    }
    var steps = ['<span class="is-done">1 case</span>'].concat(tiers.map(function (t) {
      return '<span class="' + (n >= t.qty ? 'is-done' : '') + '">' + t.qty + (t.qty === max ? '+' : '') + ' · ' + t.pct + '% off</span>';
    }));
    return '<div class="mc-tier" role="status"><div class="mc-tier__msg">' + msg + '</div>' +
      '<div class="mc-tier__bar" aria-hidden="true"><div class="mc-tier__fill" style="width:' + Math.min(100, (n / max) * 100) + '%"></div></div>' +
      '<div class="mc-tier__steps" aria-hidden="true">' + steps.join('') + '</div></div>';
  }

  function lineHTML(item) {
    var model = optOf(item, CFG.modelOption), color = optOf(item, CFG.colorOption), pack = optOf(item, CFG.packOption);
    var meta = isCase(item) ? [color, packLabel(pack)].filter(Boolean).join(' · ') : (item.variant_title || '');
    var discounted = item.final_line_price < item.original_line_price;
    var img = item.image || (item.featured_image && item.featured_image.url);
    return '<li class="mc-line" data-key="' + esc(item.key) + '">' +
      (img ? '<img class="mc-line__img" src="' + esc(imgSized(img, 180)) + '" alt="' + esc(item.product_title + (color ? ', ' + color : '')) + '" width="76" height="76" loading="lazy">' : '<div class="mc-line__img"></div>') +
      '<div><div class="mc-line__top"><p class="mc-line__title"><a href="' + esc(item.url) + '">' + esc(item.product_title) + '</a></p>' +
      '<button type="button" class="mc-line__remove" data-mc-remove aria-label="Remove ' + esc(item.product_title) + '">Remove</button></div>' +
      '<div class="mc-line__meta">' + esc(meta) + '</div>' +
      (isCase(item) && model ? '<div class="mc-line__fit">✓ Made for ' + esc(model) + '</div>' : '') +
      '<div class="mc-line__bottom"><div class="mc-qty" role="group" aria-label="Quantity">' +
      '<button type="button" data-mc-qty="-1" aria-label="One less">−</button><output aria-live="polite">' + item.quantity + '</output>' +
      '<button type="button" data-mc-qty="1" aria-label="One more">+</button></div>' +
      '<div class="mc-line__price">' + (discounted ? '<span class="mc-line__was">' + money(item.original_line_price) + '</span>' : '') + money(item.final_line_price) + '</div></div>' +
      '</div></li>';
  }

  function emptyHTML() {
    var links = CFG.emptyLinks.length ? '<div class="mc-chips">' + CFG.emptyLinks.map(function (l) {
      return '<a class="mc-chip" href="' + esc(l.url) + '">' + esc(l.label) + '</a>';
    }).join('') + '</div>' : '';
    return '<div class="mc-empty"><p class="mc-empty__title">Your bag is empty</p>' +
      '<p class="mc-empty__text">Pick your phone. Every case is cut for one exact model and ships within 24 hours.</p>' + links + '</div>';
  }

  function footHTML(cart) {
    var saved = cart.original_total_price - cart.total_price;
    var total = cart.total_price;
    var rows = '<div class="mc-summary">' +
      '<div class="mc-summary__row"><span>Bag total</span><span>' + money(cart.original_total_price) + '</span></div>' +
      (saved > 0 ? '<div class="mc-summary__row mc-summary__row--save"><span>Multi-case saving</span><span>−' + money(saved) + '</span></div>' : '') +
      '<div class="mc-summary__row"><span>Delivery</span><span>Free when you pay online</span></div>' +
      '<div class="mc-summary__row mc-summary__row--total"><span>Total <span class="mc-summary__hint">incl. GST</span></span><span>' + money(total) + '</span></div></div>';
    var nudge = CFG.prepaidSaving > 0 ? '<div class="mc-paynudge"><span aria-hidden="true">💳</span><span>Pay online and pay <b>' +
      money(Math.max(0, total - CFG.prepaidSaving * 100)) + '</b>. ₹' + CFG.prepaidSaving + ' off, free delivery, no COD confirmation step.</span></div>' : '';
    var rupees = total / 100, cod = '';
    if (rupees > CFG.codMax) cod = '<div class="mc-codnote">Cash on delivery works up to ₹' + CFG.codMax.toLocaleString('en-IN') + '. Pay online for this bag, it is ₹' + CFG.prepaidSaving + ' cheaper anyway.</div>';
    else if (rupees < CFG.codMin) cod = '<div class="mc-codnote">Cash on delivery starts at ₹' + CFG.codMin + '. UPI and cards work for any amount.</div>';
    return rows + nudge + cod +
      '<button type="button" class="mc-btn" data-mc-checkout>' +
      '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" aria-hidden="true"><rect x="4" y="11" width="16" height="10" rx="2"/><path d="M8 11V7a4 4 0 0 1 8 0v4"/></svg>' +
      'Checkout · ' + money(total) + '</button>' +
      '<div class="mc-assure"><span>' + esc(CFG.refundLine) + '</span><span>Ships in 24 hours</span><span>UPI, cards, COD</span></div>';
  }

  function render(cart) {
    cartState = cart;
    var count = cart.item_count;
    $$('[data-mc-cart-count]').forEach(function (el) { el.textContent = count; el.hidden = !count; });
    $$('[data-mc-cart]').forEach(function (root) {
      if (!count) {
        root.innerHTML = '<div class="mc-cart__scroll">' + emptyHTML() + '</div>';
        return;
      }
      root.innerHTML =
        '<div class="mc-cart__scroll">' + tierHTML(cart) +
        '<div class="mc-ship"><span aria-hidden="true">🚚</span><span>' + shipLine() + '</span></div>' +
        '<ul class="mc-lines">' + cart.items.map(lineHTML).join('') + '</ul>' +
        '<div data-mc-upsell></div><div data-mc-cart-error></div></div>' +
        '<div class="mc-cart__foot">' + footHTML(cart) + '</div>';
      renderUpsell(cart, root);
    });
  }

  /* ---------- One upsell at a time: pack upgrade first, then "add a case for someone" ---------- */
  function renderUpsell(cart, root) {
    var slot = $('[data-mc-upsell]', root); if (!slot) return;
    var cases = cart.items.filter(isCase);
    if (!cases.length) return;
    var upgradable = cases.filter(function (i) { return optOf(i, CFG.packOption) && optOf(i, CFG.packOption) !== CFG.topPack; })[0];
    var anchor = upgradable || cases[0];
    getProduct(anchor.handle).then(function (product) {
      if (upgradable) {
        var model = optOf(upgradable, CFG.modelOption), color = optOf(upgradable, CFG.colorOption);
        var target = findVariant(product, model, color, CFG.topPack);
        if (target && target.available) {
          var delta = (target.price - upgradable.original_price) * upgradable.quantity;
          var adds = (CFG.packItems[CFG.topPack] || []).filter(function (x) { return (CFG.packItems[optOf(upgradable, CFG.packOption)] || []).indexOf(x) < 0; });
          slot.innerHTML = '<div class="mc-upsell"><div class="mc-upsell__eyebrow">Cut for the same phone</div>' +
            '<p class="mc-upsell__title">Upgrade to ' + esc(packLabel(CFG.topPack)) + '</p>' +
            '<p class="mc-upsell__text">Adds ' + esc(adds.map(function (x) { return /^[A-Z][a-z]/.test(x) ? x.charAt(0).toLowerCase() + x.slice(1) : x; }).join(' and ')) + ', made for your ' + esc(model) + '.</p>' +
            '<div class="mc-upsell__row"><span class="mc-upsell__price">+' + money(delta) + '</span>' +
            '<button type="button" class="mc-btn mc-btn--sm" data-mc-upgrade="' + esc(upgradable.key) + '" data-variant="' + target.id + '" data-qty="' + upgradable.quantity + '">Upgrade</button></div></div>';
          track('mc_upsell_view', { type: 'pack_upgrade', variant_id: target.id });
          return;
        }
      }
      var n = caseCount(cart);
      var tiers = CFG.tiers.slice().sort(function (a, b) { return a.qty - b.qty; });
      var next = CFG.tiersLive ? tiers.filter(function (t) { return t.qty > n; })[0] : null;
      if (!next && CFG.tiersLive) return;   // top tier reached: no more selling, let them check out
      slot.innerHTML = familyHTML(product, next);
      track('mc_upsell_view', { type: 'family_add' });
    }).catch(function () { /* upsell is optional: fail silently */ });
  }

  function findVariant(product, model, color, pack) {
    return product.variants.filter(function (v) {
      return v.options[CFG.modelOption] === model && v.options[CFG.colorOption] === color && v.options[CFG.packOption] === pack;
    })[0];
  }
  function valuesOf(product, idx) {
    var out = [];
    product.variants.forEach(function (v) { if (out.indexOf(v.options[idx]) < 0) out.push(v.options[idx]); });
    return out;
  }
  function modelsOf(product) { return valuesOf(product, CFG.modelOption); }
  function colorsFor(product, model) {
    var seen = [];
    product.variants.forEach(function (v) {
      if ((!model || v.options[CFG.modelOption] === model) && seen.indexOf(v.options[CFG.colorOption]) < 0) seen.push(v.options[CFG.colorOption]);
    });
    return seen;
  }

  function familyHTML(product, next) {
    var models = modelsOf(product);
    var colors = picker.model ? colorsFor(product, picker.model) : [];
    if (picker.color && colors.indexOf(picker.color) < 0) picker.color = null;
    var v = picker.model && picker.color ? findVariant(product, picker.model, picker.color, CFG.basePack) : null;
    var title = next ? 'Add a case for someone at home, get ' + next.pct + '% off' : 'Add a case for someone at home';
    return '<div class="mc-upsell" data-handle="' + esc(product.handle) + '"><div class="mc-upsell__eyebrow">Any phone, any colour</div>' +
      '<p class="mc-upsell__title">' + esc(title) + '</p>' +
      '<p class="mc-upsell__text">' + (next ? 'The discount applies to every case in your bag. ' : '') + 'Which phone is it for?</p>' +
      '<div class="mc-chips" role="group" aria-label="Phone model">' + models.map(function (m) {
        return '<button type="button" class="mc-chip" data-mc-pick-model="' + esc(m) + '" aria-pressed="' + (picker.model === m) + '">' + esc(m.replace(/^Galaxy /, '').replace(/^iPhone /, '')) + '</button>';
      }).join('') + '</div>' +
      (picker.model ? '<div class="mc-chips" role="group" aria-label="Colour">' + colors.map(function (c) {
        return '<button type="button" class="mc-chip" data-mc-pick-color="' + esc(c) + '" aria-pressed="' + (picker.color === c) + '">' + esc(c) + '</button>';
      }).join('') + '</div>' : '') +
      (v ? '<div class="mc-upsell__row"><span class="mc-upsell__price">' + money(v.price) + (next ? ' <span class="mc-summary__hint">before ' + next.pct + '% off</span>' : '') + '</span>' +
        '<button type="button" class="mc-btn mc-btn--sm" data-mc-family-add="' + v.id + '"' + (v.available ? '' : ' disabled') + '>' + (v.available ? 'Add to bag' : 'Sold out') + '</button></div>' : '') +
      '</div>';
  }

  /* ---------- Cart actions ---------- */
  function showError(root, msg) {
    $$('[data-mc-cart-error]').forEach(function (el) { el.innerHTML = '<div class="mc-error" role="alert">' + esc(msg) + '</div>'; });
  }
  function refresh() { return api.get().then(render); }

  document.addEventListener('click', function (e) {
    var t = e.target;
    var line = t.closest('.mc-line');
    if (line && t.closest('[data-mc-qty]')) {
      var item = cartState.items.filter(function (i) { return i.key === line.dataset.key; })[0];
      var q = item.quantity + Number(t.closest('[data-mc-qty]').dataset.mcQty);
      line.classList.add('is-loading');
      api.change(item.key, q).then(render).catch(function (err) { line.classList.remove('is-loading'); showError(line, err.message); });
      return;
    }
    if (line && t.closest('[data-mc-remove]')) {
      line.classList.add('is-loading');
      api.change(line.dataset.key, 0).then(render).catch(function (err) { line.classList.remove('is-loading'); showError(line, err.message); });
      return;
    }
    var up = t.closest('[data-mc-upgrade]');
    if (up) {
      up.setAttribute('aria-busy', 'true');
      api.add([{ id: Number(up.dataset.variant), quantity: Number(up.dataset.qty) }])
        .then(function () { return api.change(up.dataset.mcUpgrade, 0); })
        .then(function (cart) { track('mc_upsell_accept', { type: 'pack_upgrade', variant_id: Number(up.dataset.variant) }); render(cart); })
        .catch(function (err) { up.removeAttribute('aria-busy'); showError(null, err.message); });
      return;
    }
    var pm = t.closest('[data-mc-pick-model]'), pc = t.closest('[data-mc-pick-color]');
    if (pm || pc) {
      if (pm) { picker.model = pm.dataset.mcPickModel; picker.color = null; }
      if (pc) picker.color = pc.dataset.mcPickColor;
      var box = t.closest('[data-handle]');
      getProduct(box.dataset.handle).then(function (product) {
        var tiers = CFG.tiers.slice().sort(function (a, b) { return a.qty - b.qty; });
        var next = CFG.tiersLive ? tiers.filter(function (x) { return x.qty > caseCount(cartState); })[0] : null;
        box.outerHTML = familyHTML(product, next);
      });
      return;
    }
    var fa = t.closest('[data-mc-family-add]');
    if (fa) {
      fa.setAttribute('aria-busy', 'true');
      api.add([{ id: Number(fa.dataset.mcFamilyAdd), quantity: 1 }])
        .then(function () { track('mc_upsell_accept', { type: 'family_add', variant_id: Number(fa.dataset.mcFamilyAdd) }); picker = { model: null, color: null }; return refresh(); })
        .catch(function (err) { fa.removeAttribute('aria-busy'); showError(null, err.message); });
      return;
    }
    if (t.closest('[data-mc-checkout]')) {
      var btn = t.closest('[data-mc-checkout]');
      btn.setAttribute('aria-busy', 'true');
      track('mc_begin_checkout', { value: cartState ? cartState.total_price / 100 : 0, currency: 'INR' });
      // If a checkout app (GoKwik, Shopflo, Razorpay Magic) exposes its own launcher, register it as window.MC_CHECKOUT.
      if (typeof window.MC_CHECKOUT === 'function') { window.MC_CHECKOUT(); btn.removeAttribute('aria-busy'); return; }
      window.location.href = ROOT + CFG.checkoutPath;
      return;
    }
    if (t.closest('[data-mc-close]') || t.closest('[data-mc-overlay]')) { closeDrawer(); return; }
    var opener = t.closest('[data-mc-open-cart], a[href="/cart"], a[href="' + ROOT + 'cart"]');
    if (opener && $('#mc-drawer') && !/\/cart\/?$/.test(location.pathname)) { e.preventDefault(); openDrawer(); }
  });

  /* ---------- Drawer open/close with focus trap ---------- */
  var lastFocus = null;
  function openDrawer() {
    var d = $('#mc-drawer'), o = $('[data-mc-overlay]'); if (!d) return;
    lastFocus = document.activeElement;
    d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false'); if (o) o.classList.add('is-open');
    document.documentElement.classList.add('mc-lock');
    setTimeout(function () { var c = $('[data-mc-close]', d); if (c) c.focus(); }, 60);
    refresh();
    track('mc_cart_open');
  }
  function closeDrawer() {
    var d = $('#mc-drawer'), o = $('[data-mc-overlay]'); if (!d || !d.classList.contains('is-open')) return;
    d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); if (o) o.classList.remove('is-open');
    document.documentElement.classList.remove('mc-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  document.addEventListener('keydown', function (e) {
    var d = $('#mc-drawer'); if (!d || !d.classList.contains('is-open')) return;
    if (e.key === 'Escape') { closeDrawer(); return; }
    if (e.key !== 'Tab') return;
    var f = $$('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])', d).filter(function (el) { return el.offsetParent !== null; });
    if (!f.length) return;
    if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
    else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
  });
  document.addEventListener('mc:cart:refresh', function (e) { refresh().then(function () { if (e.detail && e.detail.open) openDrawer(); }); });

  /* =========================================================
     BUY BOX (product page)
     ========================================================= */
  function initBuyBox(root) {
    var dataEl = $('[data-mc-product-json]', root); if (!dataEl) return;
    var product = safeJSON(dataEl.textContent);
    var models = modelsOf(product);
    var packs = valuesOf(product, CFG.packOption);
    var params = new URLSearchParams(location.search);
    var s = { model: null, color: null, pack: CFG.defaultPack, qty: 1, brand: 'apple' };

    // Pre-select from ?variant=, ?model=, ?color=, then last model used on this device
    var fromVariant = product.variants.filter(function (v) { return String(v.id) === params.get('variant'); })[0];
    if (fromVariant) {
      s.model = fromVariant.options[CFG.modelOption]; s.color = fromVariant.options[CFG.colorOption]; s.pack = fromVariant.options[CFG.packOption];
    } else {
      var pm = params.get('model') || store('mc_model');
      s.model = models.filter(function (m) { return slug(m) === slug(pm) || m === pm; })[0] || null;
      var pc = slug(params.get('color'));
      if (pc) s.color = colorsFor(product, s.model).filter(function (c) { return slug(c).indexOf(pc) > -1; })[0] || null;
    }
    if (packs.indexOf(s.pack) < 0) s.pack = packs[0];
    if (s.model) s.brand = isApple(s.model) ? 'apple' : 'samsung';
    var colorNote = '';

    function current() { return s.model && s.color ? findVariant(product, s.model, s.color, s.pack) : null; }
    function packPrice(pack) {
      var v = s.model && s.color ? findVariant(product, s.model, s.color, pack) : null;
      if (v) return v.price;
      return Math.min.apply(null, product.variants.filter(function (x) { return x.options[CFG.packOption] === pack; }).map(function (x) { return x.price; }));
    }
    function ensureColor() {
      var list = colorsFor(product, s.model);
      if (s.color && list.indexOf(s.color) > -1) { colorNote = ''; return; }
      var firstAvail = list.filter(function (c) { return product.variants.some(function (v) { return v.options[CFG.modelOption] === s.model && v.options[CFG.colorOption] === c && v.available; }); })[0] || list[0];
      colorNote = s.color && s.model ? esc(s.color) + ' is not made for ' + esc(s.model) + '. Showing ' + esc(firstAvail) + '.' : '';
      s.color = s.model ? firstAvail : s.color;
    }

    function draw() {
      if (s.model) ensureColor();
      var v = current();
      var unit = v ? v.price : packPrice(s.pack);
      var compare = v && v.compare_at_price > v.price ? v.compare_at_price : 0;

      // Price
      $('[data-mc-price]', root).innerHTML = '<span class="mc-price__now">' + money(unit) + '</span>' +
        (compare ? '<span class="mc-price__was">' + money(compare) + '</span><span class="mc-price__off">Save ' + money(compare - unit) + '</span>' : '') +
        '<span class="mc-price__tax">All taxes included. Pay online for ₹' + CFG.prepaidSaving + ' off and free delivery.</span>';

      // Models
      var brandModels = models.filter(function (m) { return (s.brand === 'apple') === isApple(m); });
      $('[data-mc-tabs]', root).innerHTML = ['apple', 'samsung'].map(function (b) {
        return '<button type="button" role="tab" class="mc-tab" data-mc-brand="' + b + '" aria-selected="' + (s.brand === b) + '">' + (b === 'apple' ? 'iPhone' : 'Samsung') + '</button>';
      }).join('');
      $('[data-mc-models]', root).innerHTML = brandModels.map(function (m) {
        var any = product.variants.some(function (x) { return x.options[CFG.modelOption] === m && x.available; });
        return '<button type="button" class="mc-chip" data-mc-model="' + esc(m) + '" aria-pressed="' + (s.model === m) + '"' + (any ? '' : ' disabled') + '>' + esc(m.replace(/^Galaxy /, '')) + '</button>';
      }).join('');
      $('[data-mc-model-picked]', root).textContent = s.model ? ': ' + s.model : '';

      // Colours
      var cols = colorsFor(product, s.model);
      $('[data-mc-colors]', root).innerHTML = cols.map(function (c) {
        var ok = !s.model || product.variants.some(function (x) { return x.options[CFG.modelOption] === s.model && x.options[CFG.colorOption] === c && x.available; });
        return '<button type="button" class="mc-swatch" data-mc-color="' + esc(c) + '" aria-pressed="' + (s.color === c) + '"' + (ok ? '' : ' disabled') + ' aria-label="' + esc(c) + (ok ? '' : ', sold out') + '">' +
          '<span class="mc-swatch__dot" style="background:' + (CFG.colorHex[c] || '#ddd') + '"></span><span class="mc-swatch__name">' + esc(c) + '</span></button>';
      }).join('');
      $('[data-mc-color-picked]', root).textContent = s.color ? ': ' + s.color : '';
      $('[data-mc-color-note]', root).textContent = colorNote;

      // Packs
      var base = packPrice(CFG.basePack);
      $('[data-mc-packs]', root).innerHTML = packs.map(function (p) {
        var price = packPrice(p), delta = price - base;
        return '<button type="button" role="radio" class="mc-pack" data-mc-pack="' + esc(p) + '" aria-checked="' + (s.pack === p) + '">' +
          (CFG.mostPicked === p ? '<span class="mc-pack__badge">Most picked</span>' : '') +
          '<span class="mc-pack__radio" aria-hidden="true"></span>' +
          '<span><span class="mc-pack__title">' + esc(packLabel(p)) + '</span><ul class="mc-pack__list">' +
          (CFG.packItems[p] || []).map(function (i) { return '<li>✓ ' + esc(i) + '</li>'; }).join('') + '</ul></span>' +
          '<span class="mc-pack__price">' + money(price) + (delta > 0 ? '<span class="mc-pack__delta">+' + money(delta) + '</span>' : '') + '</span></button>';
      }).join('');

      // Fit confirmation
      var fit = $('[data-mc-fit]', root);
      fit.hidden = !s.model;
      if (s.model) fit.innerHTML = '<span class="mc-fit__icon">✓</span><span>Made for <b>' + esc(s.model) + '</b> only. Not sure of your model? ' +
        (isApple(s.model) ? 'Settings › General › About' : 'Settings › About phone') + ' shows it.</span>';

      // Quantity
      $('[data-mc-qty-out]', root).textContent = s.qty;

      // CTAs
      var atc = $('[data-mc-atc]', root), buy = $('[data-mc-buynow]', root);
      if (!s.model) { atc.innerHTML = 'Select your phone'; atc.disabled = false; buy.hidden = true; }
      else if (!v || !v.available) { atc.innerHTML = 'Sold out for this phone'; atc.disabled = true; buy.hidden = true; }
      else { atc.innerHTML = 'Add to bag · ' + money(unit * s.qty); atc.disabled = false; buy.hidden = false; }
      var idInput = $('[name="id"]', root); if (idInput && v) idInput.value = v.id;

      // Sticky bar
      var sticky = $('[data-mc-sticky]');
      if (sticky) {
        $('[data-mc-sticky-title]', sticky).textContent = s.model ? [s.model, s.color, packLabel(s.pack)].filter(Boolean).join(' · ') : product.title;
        $('[data-mc-sticky-price]', sticky).textContent = money(unit * s.qty);
        $('[data-mc-sticky-btn]', sticky).textContent = !s.model ? 'Select your phone' : (v && v.available ? 'Add to bag' : 'Sold out');
        $('[data-mc-sticky-btn]', sticky).disabled = !!(s.model && (!v || !v.available));
      }

      if (v) {
        if (history.replaceState) { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u); }
        document.dispatchEvent(new CustomEvent('mc:variant:change', { detail: { variant: v } }));  // theme gallery can listen and switch image
      }
    }

    function needModel() {
      var step = $('[data-mc-step-model]', root);
      step.scrollIntoView({ behavior: 'smooth', block: 'center' });
      step.classList.remove('mc-step--attention'); void step.offsetWidth; step.classList.add('mc-step--attention');
    }

    function add(goCheckout) {
      var v = current();
      if (!s.model) { needModel(); return; }
      if (!v || !v.available) return;
      var btn = goCheckout ? $('[data-mc-buynow]', root) : $('[data-mc-atc]', root);
      btn.setAttribute('aria-busy', 'true');
      $('[data-mc-error]', root).innerHTML = '';
      api.add([{ id: v.id, quantity: s.qty }]).then(function () {
        track('mc_add_to_cart', { variant_id: v.id, value: (v.price * s.qty) / 100, currency: 'INR', model: s.model, color: s.color, pack: packLabel(s.pack) });
        if (goCheckout) {
          btn.removeAttribute('aria-busy');
          if (typeof window.MC_CHECKOUT === 'function') { window.MC_CHECKOUT(); return; }
          window.location.href = ROOT + CFG.checkoutPath; return;
        }
        btn.removeAttribute('aria-busy');
        if ($('#mc-drawer')) openDrawer(); else window.location.href = ROOT + 'cart';
      }).catch(function (err) {
        btn.removeAttribute('aria-busy');
        $('[data-mc-error]', root).innerHTML = '<div class="mc-error" role="alert">' + esc(err.message) + '</div>';
      });
    }

    root.addEventListener('click', function (e) {
      var t = e.target, b;
      if ((b = t.closest('[data-mc-brand]'))) { s.brand = b.dataset.mcBrand; draw(); return; }
      if ((b = t.closest('[data-mc-model]'))) { s.model = b.dataset.mcModel; store('mc_model', s.model); draw(); return; }
      if ((b = t.closest('[data-mc-color]'))) { s.color = b.dataset.mcColor; colorNote = ''; draw(); return; }
      if ((b = t.closest('[data-mc-pack]'))) { s.pack = b.dataset.mcPack; draw(); return; }
      if ((b = t.closest('[data-mc-step-qty]'))) { s.qty = Math.max(1, Math.min(10, s.qty + Number(b.dataset.mcStepQty))); draw(); return; }
      if (t.closest('[data-mc-atc]')) { e.preventDefault(); add(false); return; }
      if (t.closest('[data-mc-buynow]')) { e.preventDefault(); add(true); return; }
      if (t.closest('[data-mc-pin-btn]')) { checkPin(); }
    });
    var form = $('form', root); if (form) form.addEventListener('submit', function (e) { e.preventDefault(); add(false); });

    // Sticky bar visibility: show once the main button scrolls out of view
    var sticky = $('[data-mc-sticky]');
    if (sticky) {
      var anchorEl = $('[data-mc-ctas]', root) || $('[data-mc-atc]', root), ticking = false;
      var syncSticky = function () {
        ticking = false;
        var out = anchorEl.getBoundingClientRect().bottom < 0;   // shown only once the main button has scrolled above the screen
        sticky.classList.toggle('is-visible', out);
        sticky.setAttribute('aria-hidden', String(!out));
      };
      window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(syncSticky); } }, { passive: true });
      syncSticky();
      sticky.addEventListener('click', function (e) { if (e.target.closest('[data-mc-sticky-btn]')) add(false); });
    }

    // Delivery estimate
    var pinInput = $('[data-mc-pin]', root), pinOut = $('[data-mc-pin-out]', root);
    function checkPin() {
      var pin = (pinInput.value || '').replace(/\D/g, '');
      if (!/^[1-8]\d{5}$/.test(pin)) { pinOut.className = 'mc-pin__out is-error'; pinOut.textContent = 'Enter a 6-digit pincode, like 160055.'; return; }
      store('mc_pin', pin);
      var r = deliveryRange(pin);
      pinOut.className = 'mc-pin__out';
      pinOut.innerHTML = 'Delivered by <b>' + r.text + '</b> to ' + pin + '. Cash on delivery available.';
    }
    if (pinInput) {
      pinInput.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); checkPin(); } });
      var savedPin = store('mc_pin'); if (savedPin) { pinInput.value = savedPin; checkPin(); }
      else pinOut.innerHTML = 'Usually delivered <b>' + deliveryRange().text + '</b>.';
    }
    var shipEl = $('[data-mc-shipline]', root);
    if (shipEl) { shipEl.innerHTML = shipLine(); setInterval(function () { shipEl.innerHTML = shipLine(); }, 60000); }

    draw();
  }

  /* ---------------- Boot ---------------- */
  function boot() {
    $$('[data-mc-buybox]').forEach(initBuyBox);
    if ($('[data-mc-cart]')) refresh().catch(function () {});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  window.MC = { open: openDrawer, close: closeDrawer, refresh: refresh, config: CFG };
})();